// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Welcome_wrapper__3J7RS","polygon":"Welcome_polygon__1woau","imagesWrapper":"Welcome_imagesWrapper__2bciR"};